<template>
    <div class="Inspection" >
        <Title firstName="人员巡查动态" lastName="PATROL DYNAMICS"/>
        <div class="echarts">
            
            <div class="nodata">暂无人员巡查数据</div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
export default {
    data(){
        return {
            
        }
    },
    components:{
        Title,Graph,charts
    },
    mounted(){
        
    },
    methods:{
       
    },
    watch:{
        
    },
    computed:{
        
    }
}
</script>

<style lang="less" scoped>
    .Inspection{
        // height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .nodata{
                background: url(../../../../assets/img/nodata.png) no-repeat center;
                height: 25vh;
                text-align: center;
                font-size: 18rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 25vh;
                opacity: 0.7;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
    .power1{
        top: 30.3vh;
    }

</style>